/**
 * @file: ListModel.js
 * @author: liuye11(liuye11@baidu.com)
 */

import {toLower} from 'lodash';
import ListModel from './ReportListModel';

export default class Model extends ListModel {

    init() {
        super.init();
        this.materialTypeMap = this.getConstantMap('MATERIAL_TYPE');
        this.frameStatusMap = this.getConstantMap('FRAME_STATUS');
        this.trendRequester = this.api.statsComponentTrend;
        this.listRequester = this.api.statsComponentList;
    }

    adaptData(data) {
        data.result.forEach(item => {
            item.statusLabel = this.cardStatusMap[item.status];
            item.statusColor = toLower(item.status);
            item.clickRatioPercent = this.toPercentText(item.clickRatio);

            let associatedType = toLower(item.associatedType);
            item.associatedStatusLabel = this[`${associatedType}StatusMap`][item.associatedStatus];
            item.associatedTypeLabel = this.materialTypeMap[associatedType];
            item.associatedStatusColor = toLower(item.associatedStatus);
        });

        return data;
    }
}
